import classNames from 'classnames';
import { Button } from 'forms';
import React from 'react';
import type { FieldSchema, Order } from '../types';

interface Props<V extends { [k: string]: any }> {
  disabled?: boolean;
  schema: FieldSchema[];
  onOrderChange?: (order: Order<V>) => void;
  order?: Order<V>;
}

const OrderByHeadersRowCells = <V extends { [k: string]: any }>({
  disabled,
  schema,
  onOrderChange = () => {},
  order: { by = null, descending = false } = { by: null, descending: false },
}: Props<V>) => (
  <>
    {schema.map(({ name: subName, label, hidden }) => {
      if (hidden) {
        return;
      }
      const classes = classNames('order-by-header', `order-by-header-${subName}`, {
        ascending: !descending,
        descending,
        selected: String(subName) === String(by),
        unselected: String(subName) !== String(by),
      });
      return (
        <th className={classes} key={String(subName)}>
          <Button
            btn="link"
            disabled={disabled}
            icon={by === subName ? (descending ? 'chevron-down' : 'chevron-up') : 'sort'}
            onClick={() =>
              onOrderChange({
                by: by !== subName || (by === subName && !descending) ? subName : null,
                descending: by !== subName ? false : by === subName && !descending ? true : false,
              })
            }
            text={label}
          />
        </th>
      );
    })}
  </>
);

export default OrderByHeadersRowCells;
